import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: "formly-field-html",
  templateUrl: "./html.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldHtml extends FieldType {

  override defaultOptions = {
    props: {
      height: 250,
      insertTable: true,
      fontSize: true,
      fontFamily: true,
      fontColor: true,
      cleanFormatting: true,
    },
  };

  pasteCleanupSettings = {
    convertMsLists: true,
    removeHtmlComments: true,
    // stripTags: ['span', 'h1'],
    // removeAttributes: ['lang'],
    removeMsClasses: true,
    removeMsStyles: true,
    removeInvalidHTML: true,
  };

  public customStyleContent = `
        .k-content {
          font-family: Arial,"Helvetica Neue",Helvetica,sans-serif;
          font-size: 14px;
        }
    `;

}
